import { render, staticRenderFns } from "./recuperarContrasena.vue?vue&type=template&id=5888bc0d&scoped=true"
import script from "./recuperarContrasena.vue?vue&type=script&lang=js"
export * from "./recuperarContrasena.vue?vue&type=script&lang=js"
import style0 from "./recuperarContrasena.vue?vue&type=style&index=0&id=5888bc0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5888bc0d",
  null
  
)

export default component.exports